var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-ticket" }, [
    _c("div", { staticClass: "row mb-1 mb-md-2" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 d-flex flex-column flex-md-row align-items-center justify-content-between"
        },
        [
          _c(
            "h1",
            {
              staticClass:
                "pl-2 m-0 h1-responsive text-uppercase d-flex justify-content-between align-items-center"
            },
            [
              _vm.order_tickets_action
                ? _c(
                    "span",
                    {
                      staticClass:
                        "mt-1 d-flex justify-content-between align-items-center"
                    },
                    [
                      _c("i", {
                        staticClass: "mr-1 secondary-text",
                        class: _vm.nav_names.order.icon
                      }),
                      _vm._v("Tickets "),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.nav_names.order.title))
                      ])
                    ]
                  )
                : _vm.override_tickets_action
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "mt-1 d-flex justify-content-between align-items-center"
                      },
                      [
                        _c("i", {
                          staticClass: "mr-1 secondary-text",
                          class: _vm.nav_names.override.icon
                        }),
                        _vm._v("Tickets "),
                        _c("span", { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.nav_names.override.title))
                        ])
                      ]
                    )
                  : _vm.wastage_tickets_action
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "mt-1 d-flex justify-content-between align-items-center"
                        },
                        [
                          _c("i", {
                            staticClass: "mr-1 secondary-text",
                            class: _vm.nav_names.wastage.icon
                          }),
                          _vm._v("Tickets "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.nav_names.wastage.title))
                          ])
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass:
                            "mt-1 d-flex justify-content-between align-items-center"
                        },
                        [
                          _c("i", {
                            staticClass: "mr-1 secondary-text",
                            class: _vm.nav_names.config.icon
                          }),
                          _vm._v("Tickets "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.nav_names.config.title))
                          ])
                        ]
                      ),
              _vm._v(" "),
              _c("add_to_bookmark", {
                attrs: { store: _vm.bookmark_store, route: _vm.bookmark_route }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-floating btn-primary",
                  on: {
                    click: function($event) {
                      _vm.show_sub_navigation = !_vm.show_sub_navigation
                    }
                  }
                },
                [
                  _c("i", { staticClass: "material-icons fs-3" }, [
                    _vm._v("settings")
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-right" }, [
            _c("a", { attrs: { href: _vm.web_address, target: "_blank" } }, [
              _c("div", { staticClass: "font-weight-bold text-uppercase" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(
                      _vm.langData("title", _vm.event_details.event_data)
                    ) +
                    "\n                        "
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", [
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.formatDate(_vm.event_details.start_date)) +
                      "\n                            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    "\n                                " +
                      _vm._s(
                        _vm.formatDateToTime(_vm.event_details.start_date)
                      ) +
                      "\n                                -\n                                " +
                      _vm._s(_vm.formatDateToTime(_vm.event_details.end_date)) +
                      "\n                            "
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: " mb-sm-5" },
      [
        _vm.show_sub_navigation
          ? _c("event-ticket-nav", {
              attrs: {
                nav_names: _vm.nav_names,
                nav_restrictions: _vm.nav_restrictions,
                order_tickets_action: _vm.order_tickets_action,
                override_tickets_action: _vm.override_tickets_action,
                wastage_tickets_action: _vm.wastage_tickets_action,
                config_tickets_action: _vm.config_tickets_action
              },
              on: { nav_event: _vm.NavEventHandler }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.wastage_applied_toself_event ? _c("div", [_vm._m(0)]) : _vm._e(),
    _vm._v(" "),
    _vm.order_tickets_action
      ? _c(
          "div",
          [
            _c("rearrange-list", {
              attrs: {
                params: {
                  routes: {
                    read: _vm.content.urls.url,
                    update: _vm.content.urls.update_ticket_order,
                    data: null
                  },
                  collection: {
                    name: "tickets",
                    list: _vm.ticketsToEntities
                  }
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.override_tickets_action
      ? _c(
          "div",
          [
            _c("event-ticket-override", {
              attrs: {
                ticketsToEntities: _vm.ticketsToEntities,
                event_details: _vm.event_details,
                url: _vm.urls.override,
                lang: _vm.lang
              },
              on: { event: _vm.EventHandler }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.wastage_tickets_action
      ? _c(
          "div",
          [
            _c("wastage-page", {
              attrs: {
                content: {
                  read_url: _vm.urls.wastage_routes.read_url,
                  create_url: _vm.urls.wastage_routes.create_url,
                  update_url: _vm.urls.wastage_routes.update_url,
                  export_url: _vm.urls.wastage_routes.export_url,
                  close_url: _vm.urls.wastage_routes.close_url,
                  send_emails_url: _vm.urls.wastage_routes.send_emails_url
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showConfigPage()
      ? _c(
          "section",
          {
            staticClass: "watch-transition--fast",
            class: {
              "pt-5": _vm.accordion_action,
              "pt-2": !_vm.accordion_action
            }
          },
          [
            _c("section", { attrs: { id: "event-ticket--summary" } }, [
              _c(
                "div",
                { staticClass: "row mt-3 mb-2 mb-md-0" },
                _vm._l(_vm.summary.tickets, function(ticket_type, ticket_idx) {
                  return _c(
                    "div",
                    {
                      staticClass: "col-12 col-md-4 pt-5 pb-2 pt-md-0 pb-md-0"
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "list-group",
                          class: {
                            "z-depth-2":
                              _vm.summary.tickets[ticket_idx].active === true,
                            "z-depth-1":
                              _vm.summary.tickets[ticket_idx].active !== true
                          }
                        },
                        [
                          _c(
                            "li",
                            {
                              staticClass:
                                "list-group-item list-group-item-header  header d-flex justify-content-between align-items-center",
                              class: {
                                active:
                                  _vm.summary.tickets[ticket_idx].active ===
                                  true
                              },
                              on: {
                                click: function($event) {
                                  _vm.filterTicketType(ticket_idx)
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-nowrap text-uppercase text-center"
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "list-group-item-header--icon fa ",
                                    class: _vm.ticketType(ticket_idx)
                                  }),
                                  _vm._v(" "),
                                  ticket_idx === "total"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "list-group-item-header--counter"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.summary.count))
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  ticket_idx !== "total"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "list-group-item-header--counter"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(ticket_type.count))
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "list-group-item-header--title"
                                    },
                                    [_vm._v(_vm._s(ticket_idx) + " tickets")]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "list-group-item d-flex justify-content-between align-items-center"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-nowrap text-capitalize" },
                                [_vm._v("allocated")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-right font-weight-bold" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary badge-pill"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(ticket_type.allocated)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "list-group-item d-flex justify-content-between align-items-center"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-nowrap text-capitalize" },
                                [_vm._v("used")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-right font-weight-bold" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary badge-pill"
                                    },
                                    [_vm._v(" " + _vm._s(ticket_type.used))]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                })
              )
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "event-ticket--ticket" }, [
              _c("div", { staticClass: "row mt-5" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "h4-responsive align-items-center d-flex justify-content-between"
                    },
                    [
                      _c("div", [_vm._v("Tickets assigned")]),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.layout.current === "grid",
                                expression: "layout.current === 'grid'"
                              }
                            ],
                            staticClass: "btn bg-primary btn-floating",
                            class: {
                              active: _vm.layout.current === "grid",
                              "d-none": _vm.layout.current === "grid",
                              "d-md-inline-block": _vm.layout.current === "grid"
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.switchLayout("list")
                              }
                            }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons mt-0",
                                attrs: { "aria-hidden": "true" }
                              },
                              [_vm._v("view_headline")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.layout.current === "list",
                                expression: "layout.current === 'list'"
                              }
                            ],
                            staticClass: "btn bg-accent btn-floating",
                            class: {
                              active: _vm.layout.current === "list",
                              "d-none": _vm.layout.current === "list",
                              "d-md-inline-block": _vm.layout.current === "list"
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.switchLayout("grid")
                              }
                            }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons mt-0",
                                attrs: { "aria-hidden": "true" }
                              },
                              [_vm._v("toc")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.group_by_entity === true
                          ? _c(
                              "button",
                              {
                                staticClass: "btn bg-info btn-floating active",
                                on: {
                                  click: function($event) {
                                    _vm.switchGroupByEntity()
                                  }
                                }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons mt-0",
                                    attrs: { "aria-hidden": "true" }
                                  },
                                  [_vm._v("view_stream")]
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "btn bg-accent btn-floating active",
                                on: {
                                  click: function($event) {
                                    _vm.switchGroupByEntity()
                                  }
                                }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons mt-0",
                                    attrs: { "aria-hidden": "true" }
                                  },
                                  [_vm._v("view_module")]
                                )
                              ]
                            )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                !_vm.restrict_entity_import
                  ? _c("div", { staticClass: "col-md-4" }, [
                      _c(
                        "div",
                        { attrs: { id: "entity-material_select--wrapper" } },
                        [
                          _c("material-select", {
                            ref: "entity_chooser_select",
                            attrs: {
                              content: {
                                emit_controller:
                                  _vm.material_select_controllers.entity
                              },
                              id: _vm.entity_chooser.id
                            },
                            on: {
                              material_select_entity_result:
                                _vm.materialEntitySelectItemSelected,
                              material_select_entity_submit:
                                _vm.materialEntitySelectItemSelected
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "col-md-4" }),
                _vm._v(" "),
                !_vm.restrict_ticket_import
                  ? _c("div", { staticClass: "col-md-4" }, [
                      _c(
                        "div",
                        { attrs: { id: "material_select--wrapper" } },
                        [
                          _c("material-select", {
                            ref: "ticket_chooser_select",
                            attrs: {
                              content: {
                                emit_controller:
                                  _vm.material_select_controllers.ticket
                              },
                              id: _vm.ticket_chooser.id
                            },
                            on: {
                              material_select_result:
                                _vm.materialSelectItemSelected,
                              material_select_submit:
                                _vm.materialSelectItemSelected
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "col-md-4" })
              ]),
              _vm._v(" "),
              _vm.group_by_entity === true || _vm.only_group_by_entity === true
                ? _c(
                    "section",
                    {
                      attrs: {
                        "data-ref": "group_by_entity",
                        "data-grouped-by-entity": "true"
                      }
                    },
                    _vm._l(_vm.ticketsToEntities, function(entityTicket) {
                      return _c(
                        "div",
                        {
                          class: {
                            "border border-secondary p-3 z-depth-1 bg-light mb-3":
                              Object.keys(entityTicket).length > 0
                          }
                        },
                        [
                          entityTicket.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-block d-sm-flex align-items-center justify-content-sm-between"
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "text-light text-center h4-responsive m-0"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            entityTicket[0].entity.entity_data
                                              .lang.en_GB.title
                                          ) +
                                          "\n\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-block d-sm-flex align-items-center justify-content-sm-between"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 mr-0 mr-sm-2 mb-0 ml-0 d-flex justify-content-between align-items-center "
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-light mr-2" },
                                            [_vm._v("Capacity:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "badge badge-primary badge-pill"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  entityTicket[0].entity
                                                    .entity_data.capacity
                                                ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 mr-0 mr-sm-2 mb-0 ml-0 d-flex justify-content-between align-items-center"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-light mr-2" },
                                            [_vm._v("Allocated:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "badge badge-pill",
                                              class:
                                                _vm.entities_cache[
                                                  entityTicket[0].entity.id
                                                ].allocated >
                                                entityTicket[0].entity
                                                  .entity_data.capacity
                                                  ? "badge-danger"
                                                  : "badge-primary"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.entities_cache[
                                                      entityTicket[0].entity.id
                                                    ].allocated
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 mr-0 mr-sm-2 mb-0 ml-0 d-flex justify-content-between align-items-center"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-light mr-2" },
                                            [_vm._v("Used:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "badge badge-pill",
                                              class: "badge-primary"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.entities_cache[
                                                      entityTicket[0].entity.id
                                                    ].sold
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 mb-0 ml-0 d-flex justify-content-between align-items-center"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-light mr-2" },
                                            [_vm._v("Remaining:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "badge badge-pill",
                                              class:
                                                _vm.entities_cache[
                                                  entityTicket[0].entity.id
                                                ].allocated >
                                                entityTicket[0].entity
                                                  .entity_data.capacity
                                                  ? "badge-danger"
                                                  : "badge-primary"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.entities_cache[
                                                      entityTicket[0].entity.id
                                                    ].allocated >
                                                    entityTicket[0].entity
                                                      .entity_data.capacity
                                                      ? entityTicket[0].entity
                                                          .entity_data
                                                          .capacity -
                                                        _vm.entities_cache[
                                                          entityTicket[0].entity
                                                            .id
                                                        ].sold
                                                      : _vm.entities_cache[
                                                          entityTicket[0].entity
                                                            .id
                                                        ].allocated -
                                                        _vm.entities_cache[
                                                          entityTicket[0].entity
                                                            .id
                                                        ].sold
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "__body" },
                            [
                              _c(
                                "transition-group",
                                {
                                  staticClass: "row row-equal-height",
                                  attrs: {
                                    name: "expandTopLeftDown",
                                    tag: "div"
                                  }
                                },
                                _vm._l(entityTicket, function(ticket, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "mt-3 watch-transition ticket-items d-flex",
                                      class: {
                                        "col-md-6 col-lg-4":
                                          _vm.layout.current === "grid",
                                        "col-12": _vm.layout.current === "list"
                                      },
                                      attrs: { id: "item-" + ticket.id }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col watch-transition--fast card card-outline-dummy card-cascade cascading-admin-card",
                                          class: [
                                            {
                                              "card--disabled":
                                                _vm.edit_mode === true &&
                                                ticket.edit_mode !== true,
                                              "card--active ":
                                                ticket.edit_mode === true
                                            },
                                            _vm.last_ticket === ticket.id
                                              ? "z-depth-3"
                                              : "z-depth-1"
                                          ],
                                          attrs: {
                                            id: "card-selected-" + ticket.id
                                          }
                                        },
                                        [
                                          _c("event-ticket-thumb", {
                                            attrs: {
                                              ticket: ticket,
                                              ticket_types: _vm.ticket_types,
                                              methods_available:
                                                _vm.$options.methods,
                                              current_ticket:
                                                _vm.current_ticket,
                                              ticket_edit_url:
                                                _vm.urls.ticket_edit_url
                                            },
                                            on: { event: _vm.EventHandler }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "card-body p-0 pt-3"
                                            },
                                            [
                                              ticket.edit_mode === true
                                                ? _c(
                                                    "div",
                                                    {
                                                      on: {
                                                        keyup: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            !(
                                                              "button" in $event
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "enter",
                                                              13,
                                                              $event.key,
                                                              "Enter"
                                                            )
                                                          ) {
                                                            return null
                                                          }
                                                          _vm.editTicket(
                                                            ticket,
                                                            "item-" + ticket.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "event-ticket-mode-edit",
                                                        {
                                                          attrs: {
                                                            methods_available:
                                                              _vm.$options
                                                                .methods,
                                                            current_ticket:
                                                              _vm.current_ticket,
                                                            ticket: ticket,
                                                            lang: _vm.lang,
                                                            add_time_slot:
                                                              _vm.add_time_slot,
                                                            loading:
                                                              _vm.loading,
                                                            urls: _vm.urls,
                                                            index: index
                                                          },
                                                          on: {
                                                            event:
                                                              _vm.EventHandler
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        "data-ref":
                                                          "event-ticket-mode-view"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "event-ticket-mode-view",
                                                        {
                                                          attrs: {
                                                            ticket: ticket,
                                                            layout: _vm.layout,
                                                            lang: _vm.lang,
                                                            methods_available:
                                                              _vm.$options
                                                                .methods,
                                                            ticket_edit_url:
                                                              _vm.urls
                                                                .ticket_edit_url
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                })
                              )
                            ],
                            1
                          )
                        ]
                      )
                    })
                  )
                : _c(
                    "section",
                    {
                      staticClass: "row",
                      attrs: { "data-grouped-by-entity": "false" }
                    },
                    [
                      _vm._l(_vm.ticketsToEntities, function(entityTicket) {
                        return _vm._l(entityTicket, function(ticket, index) {
                          return _c(
                            "div",
                            {
                              key: ticket.id,
                              staticClass:
                                "watch-transition ticket-items d-flex",
                              class: {
                                "col-md-6": _vm.layout.current === "grid",
                                "col-12": _vm.layout.current === "list"
                              },
                              attrs: {
                                "data-element-type": "item-loop",
                                id: "item-" + ticket.id
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col watch-transition card card-outline-dummy card-cascade cascading-admin-card mb-4 mb-md-5",
                                  class: [
                                    {
                                      "card--disabled":
                                        _vm.edit_mode == true &&
                                        ticket.edit_mode !== true,
                                      "bg-white": ticket.edit_mode === true,
                                      "bg-info": ticket.edit_mode !== true
                                    },
                                    _vm.last_ticket == ticket.id
                                      ? "z-depth-3"
                                      : "z-depth-1"
                                  ],
                                  attrs: { id: "card-selected-" + ticket.id }
                                },
                                [
                                  _c("event-ticket-thumb", {
                                    attrs: {
                                      ticket: ticket,
                                      ticket_types: _vm.ticket_types,
                                      methods_available: _vm.$options.methods,
                                      current_ticket: _vm.current_ticket
                                    },
                                    on: { event: _vm.EventHandler }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "card-body p-0 pt-3" },
                                    [
                                      ticket.edit_mode === true
                                        ? _c(
                                            "div",
                                            {
                                              on: {
                                                keyup: function($event) {
                                                  if (
                                                    !("button" in $event) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  _vm.editTicket(
                                                    ticket,
                                                    "item-" + ticket.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("event-ticket-mode-edit", {
                                                attrs: {
                                                  methods_available:
                                                    _vm.$options.methods,
                                                  current_ticket:
                                                    _vm.current_ticket,
                                                  ticket: ticket,
                                                  lang: _vm.lang,
                                                  add_time_slot:
                                                    _vm.add_time_slot,
                                                  loading: _vm.loading,
                                                  urls: _vm.urls,
                                                  index: index
                                                },
                                                on: { event: _vm.EventHandler }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "col" },
                                            [
                                              _c("event-ticket-mode-view", {
                                                attrs: {
                                                  ticket: ticket,
                                                  layout: _vm.layout,
                                                  lang: _vm.lang,
                                                  methods_available:
                                                    _vm.$options.methods,
                                                  ticket_edit_url:
                                                    _vm.urls.ticket_edit_url
                                                }
                                              })
                                            ],
                                            1
                                          )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        })
                      })
                    ],
                    2
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  id: "event-ticket--confirm_alert",
                  tabindex: "-1",
                  "aria-hidden": "true"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog modal-notify modal-danger",
                    attrs: { role: "document" }
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "modal-body",
                        domProps: {
                          innerHTML: _vm._s(_vm.confirm_alert.message)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modal-footer justify-content-center" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-primary-modal waves-effect",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal"
                              },
                              on: {
                                click: function($event) {
                                  _vm.confirm_alert.call_back(
                                    _vm.confirm_alert.arg
                                  )
                                }
                              }
                            },
                            [
                              _vm._v("Yes"),
                              _c("i", { staticClass: "fa fa-cross ml-1" })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-outline-secondary-modal waves-effect",
                              attrs: { type: "button", "data-dismiss": "modal" }
                            },
                            [_vm._v("Cancel\n                            ")]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "alert alert-danger", attrs: { role: "alert" } },
      [
        _c("h5", [_vm._v("This event has wastage - Make me pretty KENI")]),
        _vm._v(" "),
        _c("h4", { staticClass: "alert-heading" }, [
          _vm._v("This event has wastage")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Wastage has been applied to tickets within this event.")
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("p", { staticClass: "mb-0" }, [
          _vm._v("Whenever you need to see wastage tickets click here")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("p", { staticClass: "heading" }, [_vm._v("Confirm")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [
          _c(
            "span",
            { staticClass: "white-text", attrs: { "aria-hidden": "true" } },
            [_vm._v("×")]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d41f5e30", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d41f5e30","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/ticketing/EventTickets.vue
// module id = 397
// module chunks = 0